import { inject } from '@angular/core';
import { WidgetTypeProvider } from '@clean-code/shared/components/ui-dashboard';
import { ChartConfigComponent } from './chart-config/chart-config.component';
import { ChartWidgetComponent } from './chart-widget/chart-widget.component';

enum WidgetTypes {
  WidgetType = 'SpreadChartWidget',
}

export function addSpreadWidget() {
  const widgetTypes = inject(WidgetTypeProvider);
  widgetTypes.add(
    WidgetTypes.WidgetType,
    ChartConfigComponent,
    ChartWidgetComponent,
    ['backoffice', 'frontoffice', 'frontoffice-int']
  );
}
